module.exports = __webpack_public_path__ + "img/joan-logo1.e7c3f34b.jpeg";